// src/customer/customer-policy/customer-policy-commission/NoRecordPlaceholder.tsx

import React from "react";
import { Button } from "../../../components";

interface INoRecordPlaceholderProps {
  date: string;
}

const NoRecordPlaceholder: React.FC<INoRecordPlaceholderProps> = ({ date }) => {
  return (
    <div className="no-record-placeholder">
      <p className="text-muted mb-3">No {date} Record</p>
      <Button
        color="primary"
        icon="add"
        onClick={() => {
          // Placeholder — functionality deferred to API integration (#99152)
        }}
      >
        Add Record
      </Button>
    </div>
  );
};

export default NoRecordPlaceholder;
